"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lazy = lazy;

/**
 * Given an function returning a Decoder, will use that decoder to decode the
 * value. This is typically used to build decoders for recursive or
 * self-referential types.
 */
function lazy(decoderFn) {
  return function (blob) {
    var decoder = decoderFn();
    return decoder(blob);
  };
}